/**
 * Public route: /r/:token
 *
 * Customers arrive here from receipt email links. Immediately redirects to
 * the server PDF download endpoint — no auth required; the token is the
 * only credential.
 *
 * Server builds these URLs in downloadToken.ts:
 *   `${PUBLIC_APP_URL}/r/${token}`
 * Server endpoint:
 *   GET /api/v1/public/receipts/download/:token
 */
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const API_BASE = import.meta.env.VITE_API_URL ?? '/api/v1';

export default function ReceiptDownloadPage() {
  const { token } = useParams<{ token: string }>();

  useEffect(() => {
    if (!token) return;
    window.location.replace(`${API_BASE}/public/receipts/download/${token}`);
  }, [token]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        background: 'var(--color-page-bg, #f8fafc)',
        color: 'var(--color-text-primary, #0f172a)',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
    >
      <p>Opening your receipt…</p>
    </div>
  );
}
